module.exports = __webpack_public_path__ + "static/media/tinh-chat-hac-sam-10ml.d2b69c4f.jpg";